import { render, staticRenderFns } from "./HoldTxnDetails.vue?vue&type=template&id=55b0bd52&scoped=true&"
import script from "./HoldTxnDetails.vue?vue&type=script&lang=js&"
export * from "./HoldTxnDetails.vue?vue&type=script&lang=js&"
import style0 from "./HoldTxnDetails.vue?vue&type=style&index=0&id=55b0bd52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b0bd52",
  null
  
)

export default component.exports